import React from 'react'
import styled, { DefaultTheme, useTheme } from 'styled-components'
import { setOpen, setSelectedDashboard } from '../../../../ducks/navigationSlice'
import { useAppDispatch } from '../../../../../redux/hooks'
import Utils from 'live/lib/utils'
import { getDashboardFilters, getModifiedSpan } from '../../../../../utils'

interface DashboardCardProps {
    dashboard: Dashboard
    image: string
    title: string
    subTitle: string
    url: string
    isActiveNode: boolean
}

export const DashboardCard: React.FC<DashboardCardProps> = (props: DashboardCardProps) => {
    const dispatch = useAppDispatch()

    const handleSelectDashboard = (): void => {
        dispatch(setOpen(false))
        dispatch(setSelectedDashboard(props.dashboard))
    }

    const getUrl = (): string => {
        let obj = getDashboardFilters(props.dashboard)

        if ((obj && (obj as any).span) || (props.dashboard && props.dashboard?.spanExpression)) {
            obj = {
                ...obj,
                ...getModifiedSpan(
                    props.dashboard,
                    (obj as any).span ? (obj as any).span : props.dashboard?.spanExpression,
                    props.isActiveNode
                )
            }
        }

        const url = new URL(
            `${window.location.origin}${props.url.substring(0, props.url.indexOf('?'))}?${[
                ...new URLSearchParams(obj).entries()
            ]
                .map(x => `${x[0]}=${encodeURI(x[1])}`)
                .join('&')}`
        )
        return url.href
    }

    const theme = useTheme() as DefaultTheme & Record<string, unknown>

    return (
        <StyledAnchor
            onClick={e => {
                if (!(e.button == 0 && e.ctrlKey)) e.preventDefault()
            }}
            href={getUrl()}
            isMobile={Utils.isMobile()}
        >
            <DashboardCardDiv
                isMobile={Utils.isMobile()}
                onClick={e => {
                    if (!e.ctrlKey) handleSelectDashboard()
                }}
            >
                <div className={`${Utils.isMobile() ? 'imageDivMobile' : 'imageDiv'}`}>
                    <img
                        src={`services/plugin-asset-metadata/thumbnail/download?mode=${theme.themeName}&dashboardName=${props.title}`}
                        alt={'thumbnail'}
                    />
                </div>
                <div className={`${Utils.isMobile() ? 'subDivMobile' : 'subDiv'}`}>
                    <div className="text">
                        <span className="title">{props.title}</span>
                        <span className="subTitle">{props.subTitle}</span>
                    </div>
                    {props.dashboard.isFavorite && (
                        <div className="favIcon">
                            <i
                                className={`${props.dashboard.isFavorite ? 'fas' : 'far'} fa-star ${
                                    props.dashboard.isFavorite ? 'active' : ''
                                }`}
                            />
                        </div>
                    )}
                </div>
            </DashboardCardDiv>
        </StyledAnchor>
    )
}

const StyledAnchor = styled.a<{ isMobile: boolean }>`
    ${props => (props.isMobile ? 'width: 100%;' : '')}
    :hover {
        text-decoration: none !important;
    }
`

const DashboardCardDiv = styled.div<{ isMobile: boolean }>`
    display: ${props => (props.isMobile ? 'unset' : 'flex')};
    flex-direction: column;
    width: ${props => (props.isMobile ? '100%' : '274px')};
    height: 100%;
    margin-top: 16px;
    border-radius: 4px;
    cursor: pointer;
    align-items: center;

    .favIcon {
        font-weight: 900;
        font-size: 14px;
        line-height: 16px;
        color: var(--gray-600);
        margin-top: 5px;

        .active {
            color: var(--yellow-700);
        }
    }

    :hover {
        background-color: var(--gray-400);
        text-decoration: none;
    }

    .imageDiv {
        width: 265px;
        margin-top: 4px;
        border: 1px solid var(--gray-400);
        background-color: var(--gray-300);
    }

    .imageDivMobile {
        margin-top: 4px;
        border: 1px solid var(--gray-400);
        background-color: var(--gray-300);
    }

    .subDiv {
        width: 265px;
        display: flex;
    }

    .subDivMobile {
        display: flex;
    }

    a {
        display: none;
    }

    .noPreview {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 12px;
        margin-top: 8px;
    }

    .chartIcon {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 86px;
        font-size: 60px;
        color: var(--gray-700);
    }

    img {
        height: 100%;
        width: 100%;
        margin: 2px;
        padding: 2px;
        border: none;
        object-fit: fill;
    }

    .text {
        height: 53px;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 4px 4px;
        background-color: transparent;

        .title {
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            color: var(--gray-800);
        }

        .subTitle {
            font-style: italic;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: var(--gray-700);
        }
    }
`
